
<template>
    <h2 v-if="!this.is_mem_load">
        {{mem_title}}
        <sup>
            <span class="badge badge-danger ml-2" v-if="is_cancel">(СКАСОВАНА ІНІЦІАТОРОМ!!!)</span>
            <span class="badge badge-danger ml-2" v-if="mem_status == -1">Службова Видалена</span>
        </sup>
    </h2>
</template>

<script >
import {mapGetters} from "vuex";

export default {
    name: "mem_sup_title",
    computed: {
        ...mapGetters({
            'memorandum': "memorandum_inside/getMemorandum",
            'is_mem_load' : "memorandum_inside/is_load"
        }),
        
        mem_title() {
            try {
                return this.memorandum.def_type + " № " + this.memorandum.number;
            }
            catch (e) {
            
            }
            
            return "";
        },
        
        mem_status() {
            if(this.memorandum.hasOwnProperty("status")) {
                return parseInt(this.memorandum.status);
            }
            
            return 100;
        },
        
        is_cancel() {
            if(this.memorandum.hasOwnProperty("canсeled")) {
                return this.memorandum.canсeled;
            }
            
            return false;
        }
        
    },
}
</script>

<style scoped>

</style>